import { useState, useCallback } from 'react';
import { ListItem } from 'common/types/common';

import { EMPTY_ARRAY } from 'shared/constants';

export type MultiSelectState = ListItem[];
export type HandleChangeMultiSelectState = (event: any, value: any[]) => void;
export type SetMultiSelectState = (value: MultiSelectState) => void;
export type ResetMultiSelectState = () => void;

export const useMultiSelectState = (initValue?: MultiSelectState) => {
  const [value, setValue] = useState<MultiSelectState>(() => (initValue || EMPTY_ARRAY));

  const handleChangeValue: HandleChangeMultiSelectState = useCallback((_, value) => {
    setValue(value || []);
  }, [setValue]);

  const resetValue = useCallback(() => {
    setValue(initValue || EMPTY_ARRAY);
  }, [setValue, initValue]);

  return [value, handleChangeValue, setValue, resetValue] as const;
};